import script from "./TopOffCounterModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopOffCounterModal.vue?vue&type=script&setup=true&lang=ts"

import "./TopOffCounterModal.vue?vue&type=style&index=0&id=3edbb3a2&scoped=true&lang=css"
script.__scopeId = "data-v-3edbb3a2"

export default script